import { MenuItem as UnstyledMenuItem } from '@mui/material'
import { alpha } from '@mui/material/styles'
import styled from '@emotion/styled'

export default styled(UnstyledMenuItem)`
  &.MuiMenuItem-root {
    position: relative;
    background-color: ${props => props.theme.palette.common.white};
    font-size: 16px;
    padding: 10px 12px;
    transition: ${props =>
      props.theme.transitions.create(['background-color'])};
    white-space: normal;
  }

  &.MuiMenuItem-root:hover {
    background-color: ${props => props.theme.palette.grey[200]};
  }

  &.MuiMenuItem-root:focus {
    background-color: ${props => alpha(props.theme.palette.primary.main, 0.25)};
    border-color: ${props => props.theme.palette.primary.main};
  }
`
